/**
 * FAIR Inputs registry — Figma nodes:
 * 1:5172 AutoComplete, 1:5717 Dropdown, 1:6999 Input, 1:5198 _inputlist-item, 1:7294 Text area
 */

import type { FairIconName } from './icons.data'

export const FAIR_INPUT_TEXT_VARIANTS = ['outlined', 'flat', 'underline'] as const
export type FairInputTextVariant = (typeof FAIR_INPUT_TEXT_VARIANTS)[number]

export const FAIR_INPUT_TEXT_STATES = [
  'default',
  'hover',
  'active',
  'disabled',
] as const
export type FairInputTextPreviewState = (typeof FAIR_INPUT_TEXT_STATES)[number]

export const FAIR_TEXTAREA_DEVICES = ['desktop', 'mobile'] as const
export type FairTextareaDevice = (typeof FAIR_TEXTAREA_DEVICES)[number]

export const FAIR_TEXTAREA_STATES = [
  'default',
  'hover',
  'active',
  'completed',
] as const
export type FairTextareaPreviewState = (typeof FAIR_TEXTAREA_STATES)[number]

export const FAIR_INPUT_LIST_ITEM_STATES = [
  'default',
  'hover',
  'highlight',
  'disabled',
] as const

export type FairInputListItemState = (typeof FAIR_INPUT_LIST_ITEM_STATES)[number]

export const FAIR_INPUT_SELECT_STATES = ['idle', 'open', 'selected'] as const
export type FairInputSelectState = (typeof FAIR_INPUT_SELECT_STATES)[number]

export type FairMultiSelectMode = 'template' | 'list'

/** @deprecated Use FAIR_INPUT_SELECT_STATES */
export const FAIR_AUTOCOMPLETE_STATES = FAIR_INPUT_SELECT_STATES
/** @deprecated Use FairInputSelectState */
export type FairAutocompleteState = FairInputSelectState

export interface FairAutocompleteOption {
  key: string
  label: string
  value?: unknown
  disabled?: boolean
  ai?: boolean
  emoji?: string
  description?: string
  count?: string
  icon?: FairIconName
  trailingIcon?: FairIconName
  checkbox?: boolean
  checked?: boolean
  children?: FairAutocompleteOption[]
}

export interface FairAutocompleteGroup {
  key: string
  label: string
  emoji?: string
  icon?: FairIconName
  items: FairAutocompleteOption[]
}

export type FairAutocompleteSuggestions =
  | FairAutocompleteOption[]
  | FairAutocompleteGroup[]

export interface FairAutocompleteFlatItem {
  kind: 'option' | 'group'
  key: string
  depth: number
  option?: FairAutocompleteOption
  group?: FairAutocompleteGroup
  treeNode?: boolean
  expanded?: boolean
  hasChildren?: boolean
}

export function isGroupedSuggestions(
  suggestions: FairAutocompleteSuggestions,
): suggestions is FairAutocompleteGroup[] {
  if (!suggestions.length) {
    return false
  }

  return 'items' in suggestions[0]
}

export interface FairDropdownOption {
  key: string
  label: string
  value?: unknown
  disabled?: boolean
  description?: string
  icon?: FairIconName
}

export interface FairDropdownGroup {
  key: string
  label: string
  emoji?: string
  icon?: FairIconName
  items: FairDropdownOption[]
}

export type FairDropdownOptions =
  | FairDropdownOption[]
  | FairDropdownGroup[]

export interface FairDropdownFlatItem {
  kind: 'option' | 'group'
  key: string
  option?: FairDropdownOption
  group?: FairDropdownGroup
}

export function isGroupedDropdownOptions(
  options: FairDropdownOptions,
): options is FairDropdownGroup[] {
  if (!options.length) {
    return false
  }

  return 'items' in options[0]
}
